import { ARROWHEAD_BARB_WIDTH, ARROWHEAD_MARKERS } from '@peruselab/structure-editor/rendering/arrowheadMarkers';
import { roundToOneDecimal } from '@peruselab/structure-editor/domain/geometry';

interface ArrowheadDefsProps {
  // Matches the depiction's labelScale so heads shrink with a fitted large molecule; viewport
  // zoom then scales them further via the parent <svg> viewBox (#391, same rule as #385/#387).
  readonly scale?: number;
}

// #391 - the in-canvas twin of rendering/arrowheadMarkers.ts's `arrowheadDefs()` string: the same
// <marker> catalog, generated from the same `ARROWHEAD_MARKERS`, emitted as JSX for
// PaperVectorLayer (and any other in-app SVG). Heads paint with `context-stroke` so each takes
// the referencing line's own stroke colour.
export function ArrowheadDefs({ scale = 1 }: ArrowheadDefsProps) {
  return (
    <defs>
      {ARROWHEAD_MARKERS.map((spec) => (
        <marker
          key={spec.id}
          id={spec.id}
          viewBox={`0 0 ${spec.length} ${spec.width}`}
          refX={spec.refX}
          refY={spec.refY}
          markerWidth={roundToOneDecimal(spec.length * scale)}
          markerHeight={roundToOneDecimal(spec.width * scale)}
          markerUnits="userSpaceOnUse"
          orient="auto"
        >
          {spec.shapes.map((shape, index) =>
            shape.filled ? (
              <path key={index} d={shape.d} fill="context-stroke" />
            ) : (
              <path
                key={index}
                d={shape.d}
                fill="none"
                stroke="context-stroke"
                strokeWidth={ARROWHEAD_BARB_WIDTH}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            )
          )}
        </marker>
      ))}
    </defs>
  );
}
